import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category10 from "../../components/category/Category10";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; 

import Breadcrumb from "../../components/breadcrumb";
import { CartContext } from "../../CartContext";
import emptyCartImage from "../../assets/siteimages/Empty-Cart.png";

Cart.propTypes = {};

function Cart(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); 
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); 
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); 
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); 
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

   const { cartItems, removeFromCart } = useContext(CartContext);
   const total = cartItems.reduce((sum, item) => sum + parseFloat(item.Price), 0);


const [customer, setCustomer] = useState(null);

useEffect(() => {
  const fetchCustomer = async () => {
    try {
      const storedUserId = localStorage.getItem("userId");

      if (!storedUserId || storedUserId === "guest_user") {
        console.log("⚠️ No logged-in user found");
        return;
      }

      console.log("👤 Fetching customer:", storedUserId);

      const { data } = await axios.get(
        `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${storedUserId}`
      );

      console.log("✅ Customer loaded:", data);

      setCustomer({
        fullName: data.Named || "",
        email: data.Email || "",
        contactNo: String(data.Cno || ""),
      });

    } catch (err) {
      console.error("❌ Error fetching customer:", err);
    }
  };

  fetchCustomer();
}, []);

const handleRazorpayPayment = async () => {
  try {
    console.log("🛒 Starting Razorpay payment");

    const userId = localStorage.getItem("userId");

    if (!userId || userId === "guest_user") {
      alert("Please login before making a payment.");
      return;
    }

    // ---------------------------------------
    // 1. Calculate final payable amount
    // ---------------------------------------

    const finalAmount = Number(
      (total - discountAmount).toFixed(2)
    );

    console.log("💰 Cart Total:", total);
    console.log("💸 Discount:", discountAmount);
    console.log("💳 Final Amount:", finalAmount);

    if (!finalAmount || finalAmount <= 0) {
      alert("Invalid payment amount.");
      return;
    }

    // ---------------------------------------
// 2. Make sure customer record exists
// Email and contact are OPTIONAL
// ---------------------------------------

let customerInfo = customer;

// If customer data has not loaded yet,
// fetch it before proceeding.
if (!customerInfo) {
  console.log("⏳ Customer data not ready. Fetching now...");

  const response = await axios.get(
    `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${userId}`
  );

  console.log(
    "✅ Customer fetched before payment:",
    response.data
  );

  customerInfo = {
    fullName: response.data.Named || "",
    email: (response.data.Email || "").trim(),
    contactNo: String(response.data.Cno || ""),
  };

  setCustomer(customerInfo);
}

// ---------------------------------------
// 3. Validate customer record
// Do NOT require email or contact number
// ---------------------------------------

if (!customerInfo) {
  console.error(
    "❌ Customer information unavailable:",
    customerInfo
  );

  alert(
    "Unable to load your customer information. Please try again."
  );

  return;
}

console.log("✅ Customer ready for payment:", {
  fullName: customerInfo.fullName,
  email: customerInfo.email || "(not provided)",
  contactNo: customerInfo.contactNo || "(not provided)",
});

    // ---------------------------------------
    // 4. Create Razorpay order
    // ---------------------------------------

    console.log("📦 Creating Razorpay order...");

    const formattedCartItems = cartItems.map((item) => ({
  courseId: item.Id,
  courseName: item.Title,
  coursePrice: parseFloat(item.Price) || 0,
  validity: item.Validity,
}));

const { data } = await axios.post(
  "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/razorpay/pay",
  {
    userId,
    amount: finalAmount,

    // Original cart total
    price1: total,

    // Promo information
    promoCode: appliedPromo?.Code || null,
    discountAmount: discountAmount || 0,

    // Final amount actually paid
    netamt: finalAmount,

    // IMPORTANT
    cartItems: formattedCartItems,
  }
);

    console.log("✅ Razorpay order created:", data);

    // ---------------------------------------
    // 5. Store payment information
    // ---------------------------------------

    localStorage.setItem(
      "paymentAmount",
      total.toString()
    );

    localStorage.setItem(
      "paymentUserId",
      userId
    );

    localStorage.setItem(
      "razorpayOrderId",
      data.orderId
    );

    if (appliedPromo) {
      localStorage.setItem(
        "promoCode",
        appliedPromo.Code
      );

      localStorage.setItem(
        "discountAmount",
        discountAmount.toString()
      );
    } else {
      localStorage.removeItem("promoCode");
      localStorage.removeItem("discountAmount");
    }

    // ---------------------------------------
    // 6. Open Razorpay
    // ---------------------------------------

    const options = {
      key: data.key,
      amount: data.amount,
      currency: data.currency,
      name: "Adhigyanam",
      description: "Course Purchase",
      order_id: data.orderId,

      prefill: {
        name: customerInfo.fullName,
        email: customerInfo.email,
        contact: customerInfo.contactNo,
      },

      readonly: {
        contact: true,
        email: true,
      },

      handler: function (response) {

        console.log("✅ Razorpay payment completed");
        console.log("Payment ID:", response.razorpay_payment_id);
        console.log("Order ID:", response.razorpay_order_id);
        console.log(
          "Signature:",
          response.razorpay_signature
        );

        localStorage.setItem(
          "transactionId",
          response.razorpay_payment_id
        );

        localStorage.setItem(
          "razorpayOrderId",
          response.razorpay_order_id
        );

        window.location.href =
          `https://adhigyanam.com/payment-status?tid=${response.razorpay_payment_id}`;
      },

      theme: {
        color: "#198754",
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.on("payment.failed", function (response) {

      console.error(
        "❌ Razorpay payment failed:",
        response.error
      );

      alert("Payment failed. Please try again.");
    });

    razorpay.open();

  } catch (error) {

    console.error(
      "❌ Payment initiation failed:",
      error.response?.data || error.message
    );

    alert("Payment initiation failed. Please try again.");
  }
};





const [promoCode, setPromoCode] = useState("");
const [discountAmount, setDiscountAmount] = useState(0);
const [promoMessage, setPromoMessage] = useState("");
const [appliedPromo, setAppliedPromo] = useState(null);


const handleApplyPromo = async () => {
  const userId = localStorage.getItem("userId");

  if (!promoCode) {
    setPromoMessage("Please enter a promo code.");
    return;
  }

  try {
    const response = await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/validatepromocode",
      {
        code: promoCode,
        userId,
      }
    );

    const {
      valid,
      discountType,
      discountPercent,
      discountAmount: cashDiscount,
      promoRecord,
      message,
    } = response.data;

    if (!valid) {
      setDiscountAmount(0);
      setAppliedPromo(null);
      setPromoMessage(message || "Promo code not valid.");
      return;
    }

    let discount = 0;

    // ✅ CASH DISCOUNT
    if (Number(discountType) === 0) {
      discount = parseFloat(cashDiscount) || 0;
    }

    // ✅ PERCENT DISCOUNT
    if (Number(discountType) === 1) {
      discount = (total * parseFloat(discountPercent || 0)) / 100;
    }

    // Safety: discount should not exceed cart total
    if (discount > total) discount = total;

    setDiscountAmount(discount);
    setAppliedPromo(promoRecord);
    setPromoMessage(`Promo applied! You saved ₹${discount.toFixed(2)}.`);

    // Save to localStorage
    localStorage.setItem("promoCode", promoCode);
    localStorage.setItem("discountAmount", discount.toString());

  } catch (error) {
    console.error("Promo code validation failed", error);
    setDiscountAmount(0);
    setAppliedPromo(null);
    setPromoMessage("Something went wrong while validating promo code.");
  }
};

const handleRemovePromo = () => {
  setPromoCode(""); // Clear input field
  setDiscountAmount(0);
  setAppliedPromo(null);
  setPromoMessage("");

  localStorage.removeItem("promoCode");
  localStorage.removeItem("discountAmount");
};
  
  return (
    <>
    <Helmet>
            <title>Your Cart - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
      

     <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>

           <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
        </div>
      </div>

      
      <Header2 clname="act1" handleMobile={handleMobile} />
        <Breadcrumb title="Your Shopping Cart" />
     
        <div style={{ fontFamily: "Arial, sans-serif", maxWidth:"1200px", margin:"auto", padding:"20px" }}>
      {cartItems.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "0px", marginBottom: "20px" }}>
          <img
            src={emptyCartImage}
            alt="Empty Cart"
            style={{ width: "280px", opacity: 0.9 }}
          />
          <h6 style={{ color: "#555", marginTop: "20px" }}>Your cart is empty!</h6>
          <p style={{ color: "#888" }}>Add some courses to get started.</p>
            <div className="header-customize-item button" style={{
              background:"none",
              backgroundColor:"#14a077",
              borderRadius: "4px",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "26px",
              color: "#ffffff",
              borderColor: "transparent",
              textTransform: "capitalize", marginRight:"6px", maxWidth:"200px", padding:"10px 20px", margin:"auto", marginTop:"15px"}}>
                            <Link to="/allcourses" style={{color: "#ffffff"}}>Browse Courses</Link>
                          </div>
                          
        </div>
      ) : (
        <div>
          <h6 style={{ marginBottom: "20px", color: "#333", fontSize:"17px", marginTop:"30px" }}>Welcome To Your Cart</h6>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f7f7f7", textAlign: "left" }}>
                <th style={thStyle}>Course</th>
                <th style={thStyle}>Price</th>
                <th style={thStyle}>Validity</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item) => (
                <tr key={item.Id} style={{ borderBottom: "1px solid #eee" }}>
                  <td style={tdStyle}><b>{item.Title}</b></td>
                  <td style={tdStyle}>₹{parseFloat(item.Price).toFixed(2)}</td>
                  <td style={tdStyle}>{item.Validity} days</td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => removeFromCart(item.Id)}
                      style={removeBtnStyle}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

<div className="tf-container">
        
          <div className="row">



         

            <div className="col-lg-6 col-md-12" style={{padding:"0px"}}>
 <div style={{marginTop:"20px", marginBottom:"20px"}}>
  <input
    type="text"
    value={promoCode}
    onChange={(e) => setPromoCode(e.target.value)}
    placeholder="Enter Promo Code"
    style={{
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      marginRight: "5px",
      flex: 1,
      maxWidth: "200px", color:"black", fontWeight:"bold", textTransform:"uppercase", backgroundColor:"#fafafa"
    }}
  />
  <button
    onClick={handleApplyPromo}
    style={{
      backgroundColor: "#14a077",
      color: "#fff",
      padding: "19px 20px",
      border: "none",
      borderRadius: "4px",
      fontWeight: "bold",
      cursor: "pointer"
    }}
  >
    Apply
  </button>
   <button
     onClick={handleRemovePromo}
    style={{
      backgroundColor: "black",
      color: "#fff",
      padding: "19px 20px",
      border: "none",
      borderRadius: "4px",
      fontWeight: "bold",
      cursor: "pointer", marginLeft:"5px"
    }}
  >
    Remove
  </button>
</div>

{promoMessage && (
  <p style={{ color: appliedPromo ? "green" : "red", fontWeight: "bold", marginBottom: "20px", backgroundColor:"#fafafa", padding:"10px" }}>
    {promoMessage}
  </p>
)}
            </div>
            <div className="col-lg-6 col-md-12" style={{padding:"0px", marginBottom:"0px"}}>
              <div style={{ textAlign: "right", marginTop:"20px" }}>
  <p style={{ fontSize: "16px", margin: 0 }}>Cart Total: ₹{total.toFixed(2)}</p>
  {discountAmount > 0 && (
    <p style={{ fontSize: "16px", color: "green", margin: 0 }}>
      Discount: - ₹{discountAmount.toFixed(2)}
    </p>
  )}
  <p style={{ fontSize: "17px", fontWeight: "600", marginTop: "15px" }}>
    Amount Payable: ₹{(total - discountAmount).toFixed(2)}
  </p>
 
<button
  onClick={handleRazorpayPayment} style={{
              background:"none",
              backgroundColor:"#14a077",
              borderRadius: "4px",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "26px",
              color: "#ffffff",
              borderColor: "transparent",
              textTransform: "capitalize", marginRight:"6px", maxWidth:"200px", padding:"10px 20px", marginTop:"10px"}}
>
  Proceed To Pay
</button>
</div>
            </div>

            </div></div>



     
      

 
                         
        
          
        </div>
      )}
    </div>
      
      <div
                className="floating-buttons"
                style={{
                  position: "fixed",
                  bottom: "20px",
                  left: "20px",
                  zIndex: "1000",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
               
                <a
                  href={`tel:+918960708425`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#007BFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaPhoneAlt />
                </a>
              
               
                <a
                  href={`https://wa.me/918960708425`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#25D366",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaWhatsapp />
                </a>
              </div>
      <Footer />
      <Gotop />
    </>
  );
}

const thStyle = {
  padding: "12px",
  borderBottom: "2px solid #ddd",
  color: "#444",
  fontSize: "15px",
  fontWeight:"bold"
};

const tdStyle = {
  padding: "12px",
  fontSize: "14px",
  color: "#555",
};

const removeBtnStyle = {
  backgroundColor: "#e74c3c",
  color: "#fff",
  padding: "6px 12px",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "13px",
};

export default Cart;
